'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { logSentryError } from 'shared/utils/logSentry';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { Dictionaries, getSynergiecareersDictionary, Locale } from 'shared/i18n/i18n-config';
import AppLayout from '../../components/AppLayout';
import { getLocaleFromPathname } from 'shared/utils/getLocale';
import ErrorPage from 'shared/pages/CustomError';

type Props = {
  error: Error & { digest?: string };
};

export default function CustomErrorPage({ error }: Props) {
  let errorMessage = 'internal-server-error';
  if (error && error.message) errorMessage = error.message;
  const pathname = usePathname();
  const locale: Locale = pathname ? getLocaleFromPathname(pathname) : 'nl';
  const [dictionary, setDictionary] = useState<Partial<Dictionaries> | null>(null);
  useEffect(() => {
    const getDictionary = async () => {
      try {
        setDictionary(await getSynergiecareersDictionary(locale));
      } catch (error) {
        console.error('cannot get dictionary:', error);
      }
    };

    getDictionary();
  }, [locale]);

  useEffect(() => {
    // Log the error to Sentry
    logSentryError(error);
  }, [error]);
  // Wrap the text in an element: browser translation replaces bare text nodes, after which
  // React can no longer remove them and the error boundary itself crashes in a loop.
  if (!dictionary) return <div>{errorMessage}</div>;

  return (
    <AppLayout
      availableLocales={[
        { locale: 'nl', pathname: `/something-went-wrong/` },
        { locale: 'fr', pathname: `/something-went-wrong/` },
      ]}
      dictionary={dictionary}
    >
      <ErrorPage dictionary={dictionary} />
    </AppLayout>
  );
}
